import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { addUser, getUserById, updateUser } from "../services/UserAPI";
import { FiLogOut } from 'react-icons/fi';

const AddUser = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // <-- get user id from URL
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    role: "user",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const getUser = async (id) => {
    if (id) {
      setIsEdit(true);
      setLoading(true);
      const user = await getUserById(id);
      setFormData({ ...user });
      setLoading(false);
    }
  };

  useEffect(() => {
    //console.log("id", id)

    getUser(id);
    // }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    console.log("handleSubmit...")
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    const userRecord ={
          name: formData.name,
          email: formData.email,
          role: formData.role,
          ...(formData.password ? { password: formData.password } : {}),
        id};
        console.log(userRecord);
    try {
      if (isEdit) {
        await updateUser(userRecord)
        setSuccess("User updated successfully!!!!");
        navigate('/home');
      }
      else {
        const data = await addUser(formData);
        setFormData(data);
        navigate('/home');
      }
    } catch (error) {
      setError(isEdit ? "Failed to update user" : "Failed to add user");
    }

    finally {
      setLoading(false);
    }
  }

  const handleCancel = () => {
    navigate("/home");
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <header className="bg-white shadow-sm">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <h1 className="text-xl font-semibold text-gray-900">{isEdit ? "Edit User" : "Add User"}</h1>
            <nav className="flex space-x-8">
              <a
                onClick={() => { navigate("/home") }}
                className="px-6 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 transition-all duration-200"
              >
                Users
              </a>
              <button onClick={handleLogout} className="text-red-500 hover:text-red-700 px-3 py-2 rounded-md text-sm font-medium">
                <FiLogOut />
              </button>
            </nav>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white shadow-xl rounded-lg overflow-hidden">
          <div className="bg-blue-700 px-6 py-4">
            <h2 className="text-2xl font-bold text-white">{isEdit ? "Edit User" : "Add New User"}</h2>
          </div>

          <form onSubmit={handleSubmit} className="px-6 py-6 sm:p-8">
            {error && (
              <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded">
                <p>{error}</p>
              </div>
            )}

            {success && (
              <div className="mb-6 p-4 bg-green-50 border-l-4 border-green-500 text-green-700 rounded">
                <p>{success}</p>
              </div>
            )}

            <div className="space-y-6">
              <div>
                <label
                  htmlFor="name"
                  className="block text-md font-medium text-gray-700 mb-1"
                >
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  onChange={handleChange}
                  value={formData.name || ""}
                  className="w-full px-4 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder="Enter name"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block text-md font-medium text-gray-700 mb-1"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  onChange={handleChange}
                  value={formData.email || ""}
                  className="w-full px-4 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder="user@example.com"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="password"
                  className="block text-md font-medium text-gray-700 mb-1"
                >
                  Password {id && <span className="text-xs text-gray-500">(Leave blank to keep unchanged)</span>}
                </label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  onChange={handleChange}
                  value={formData.password || ""}
                  className="w-full px-4 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder={isEdit ? "Leave blank to keep current password" : "password"}
                  required={!isEdit}
                />
              </div>
              <div>
                <label
                  htmlFor="role"
                  className="block text-md font-medium text-gray-700 mb-1"
                >User Role
                </label>
                <select
                  id="role"
                  name="role"
                  onChange={handleChange}
                  value={formData.role || ""}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white"
                >
                  <option value="">Select a role</option>
                  <option value="super admin">Super Admin</option>
                  <option value="sales">Sales</option>
                  <option value="admin">Admin</option>
                  <option value="IT">IT</option>
                </select>
              </div>
            </div>

            <div className="mt-8 pt-5  flex justify-end space-x-3">
              <button
                type="button"
                onClick={handleCancel}
                className="px-6 py-2 border border-gray-300 rounded-lg shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 transition-all duration-200"
                disabled={loading}
              >
                {isEdit ? "Update User" : "Add User"}
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddUser;